import { useUserRepository } from 'new/state/users';
import { User } from 'new/entities/User';
import {
  CREDENTIAL_VALID,
  CREDENTIAL_INVALID,
  CREDENTIAL_UNTESTED,
} from 'js/constants/credentialStatus';

type OwnerFields = Pick<User, 'id' | 'full_name' | 'email'>;

type CredentialWidgetData = {
  credentialId: number;
  credentialName: string;
  owner: OwnerFields | null;
  status: 'valid' | 'invalid' | 'untested';
};

function pickOwnerFields(user: User): OwnerFields {
  return {
    id: user.id,
    full_name: user.full_name,
    email: user.email,
  };
}

const VALID_STATUSES = [CREDENTIAL_VALID, CREDENTIAL_INVALID, CREDENTIAL_UNTESTED];

/**
 * Resolve the current owner and status for the shared credential widget.
 * @example const widgetProps = useCredentialWidgetData(credential);
 */
export function useCredentialWidgetData(credential: any): CredentialWidgetData | null {
  const { getUserById } = useUserRepository();

  if (!credential) return null;

  const ownerUser = credential.owner ? getUserById(credential.owner) : null;
  const owner = ownerUser ? pickOwnerFields(ownerUser) : null;

  const status: CredentialWidgetData['status'] = VALID_STATUSES.includes(credential.validStatus)
    ? credential.validStatus
    : CREDENTIAL_UNTESTED;

  return {
    credentialId: credential.id,
    credentialName: credential.name,
    owner,
    status,
  };
}
